import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import {
  ContractorCitationStatus,
  CONTRACTOR_CITATION_STATUS_LABELS,
  BadgeVariant
} from '@umss/shared/utils';
import { UmssBadgeComponent } from '../badge/badge.component';

const CITATION_STATUS_VARIANT: Record<ContractorCitationStatus, BadgeVariant> =
  {
    [ContractorCitationStatus.Open]: 'error',
    [ContractorCitationStatus.Resolved]: 'success'
  };

/**
 * Component to display a badge based on contractor citation status.
 * Shows the status label (e.g., "Open", "Resolved") with the appropriate color variant.
 */
@Component({
  selector: 'umss-citation-status-badge',
  standalone: true,
  imports: [UmssBadgeComponent],
  template: `
    @if (label) {
      <umss-badge [variant]="variant" [label]="label" [size]="size" />
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UmssCitationStatusBadgeComponent {
  private _status!: ContractorCitationStatus;

  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input({ required: true }) set status(value: ContractorCitationStatus) {
    this._status = value;
    this.label = CONTRACTOR_CITATION_STATUS_LABELS[this._status];
    this.variant = CITATION_STATUS_VARIANT[this._status];
  }
  get status(): ContractorCitationStatus {
    return this._status;
  }

  label: string | undefined;
  variant: BadgeVariant = 'neutral';
}
